import { z } from 'zod';

export const passwordSchema = z
    .string()
    .min(8, { message: 'Must be at least 8 characters' })
    .refine((value) => /[A-Z]/.test(value), {
        message: 'Must contain at least one uppercase character',
    })
    .refine((value) => /[a-z]/.test(value), {
        message: 'Must contain at least one lowercase character',
    })
    .refine((value) => /\d/.test(value), {
        message: 'Must contain at least one number',
    })
    .refine((value) => /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(value), {
        message: 'Password must contain a special character',
    });

export const FormSchema = z
    .object({
        currentPassword: z.string().min(6),
        newPassword: passwordSchema,
        retypeNewPassword: passwordSchema,
    })
    .refine((data) => data.newPassword === data.retypeNewPassword, {
        message: 'Passwords do not match',
        path: ['retypeNewPassword'],
    })
    .refine((data) => data.newPassword !== data.currentPassword, {
        message: 'New password must not be the same as current password',
        path: ['newPassword'],
    });
